import { render, staticRenderFns } from "./SituationGallery.vue?vue&type=template&id=64546ffe&scoped=true&"
import script from "./SituationGallery.vue?vue&type=script&lang=js&"
export * from "./SituationGallery.vue?vue&type=script&lang=js&"
import style0 from "./SituationGallery.vue?vue&type=style&index=0&id=64546ffe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64546ffe",
  null
  
)

export default component.exports